import { registerServiceWorkerAndNotifyOuterDocument } from '@fullstory/service-worker-registration';

const workerHref = '/s/playback-service-worker.js';
const scope = '/s/playback/';
registerServiceWorkerAndNotifyOuterDocument(workerHref, scope);
